import {useCallback} from 'react';

import {useLazyQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAiSearchResults as GetAiSearchResultsQuery,
    GetAiSearchResultsVariables as GetAiSearchResultsQueryVariables,
} from 'nutshell-graphql-types';

import GET_AI_SEARCH_RESULTS from '../queries/get-ai-search-results.graphql';

export function useGetAiSearchResults() {
    const [executeSearch, {data, loading: isLoading, error}] = useLazyQuery<
        GetAiSearchResultsQuery,
        GetAiSearchResultsQueryVariables
    >(GET_AI_SEARCH_RESULTS, {
        fetchPolicy: 'network-only',
    });

    const executeAiSearch = useCallback(
        (query: string) => executeSearch({variables: {query}}),
        [executeSearch]
    );

    const aiResults = data?.aiSearch ?? null;

    return {
        executeAiSearch,
        aiResults,
        isAiLoading: isLoading,
        // @ts-expect-error
        aiError: safelyGetGraphQLErrorMessage(error),
    };
}
